<div id="header-container">
    <div id="navbar-brand">
        <i class="menu-icon fas fa-bars"></i>
        <span *ngIf="profile$ | async as profile" class="ml-3">
            {{ profile.supplier.nameTH }}
            <span *ngIf="profile.nickName">({{ profile.nickName }})</span>
        </span>
    </div>
</div>
